import React from "react";
import "./index.css";
import { Container } from "react-bootstrap";
import SectionTitle from "@/components/common-components/SectionTitle";
import ContactCard from "./ContactCard";
import Link from "next/link";
import { socialIcons } from "@/utlility/Constants";
import CustomForm from "@/components/common-components/form/CustomForm";

const FormSection = ({ addressData, headerData }) => {

  const linkData = (name) => {
    switch (name) {
      case "Facebook":
        return `${headerData?.facebook_link}`;
      case "Instagram":
        return `${headerData?.instagram_link}`;
      // case "Twitter":
      //   return `${headerData?.twitter_link}`;
      case "Youtube":
        return `${headerData?.youtube_link}`;
    }
  };

  return (
    <section className="contact-us">
      <Container>
        <div className="text-center ">
          <SectionTitle
            sectionName={"Contact Us"}
            title={"Drop us a line"}
          />
        </div>
        <div className="contact-us-grid contact-us-cover">
          <div className="contact-form-wrapper">
            <div
              className="rounded description form-shadow mx-auto contact-us"
            >
              <h3 className="form-title">Send us a message</h3>
              <CustomForm
                onHide={() => { }}
                variant="contact-us-form"
              />

            </div>
          </div>
          <div className="contact-card-wrapper">
            <div className="card-cover">
              <h3 className="form-title">
                Hi! We are always here to help you.
              </h3>
              <div className="d-flex flex-column contact-cover">
                <ContactCard addressData={addressData?.data} />
              </div>
              <hr className="line opacity-100" />
              <h3 className="social fw-medium">Connect with us</h3>
              <div className="d-flex gap-3 gap-md-4 social-icons">
                {socialIcons.map((item, i) => {
                  const url = linkData(item.name);
                  return (
                    <Link
                      key={i}
                      href={url}
                      target="_blank"
                      aria-label={item.name}
                      className="rounded-circle d-flex align-items-center justify-content-center position-relative overflow-hidden icon"
                    >
                      <i className="position-relative z-1">
                        {item.icon}
                      </i>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FormSection;
